import { UrlConstants } from '../constants/url.constants';

export class LoginService {
  static host = UrlConstants.backend;
  static async login(email, password) {
    const apiPath = '/login';
    try {
      const response = await fetch(`${this.host}${apiPath}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });
      if (!response.ok) {
        throw new Error('Failed to login');
      }

      console.log(response);
      return response;
    } catch (error) {
      console.error('Error while attempting to login :: ', error);
      throw error;
    }
  }
}
